export default __webpack_public_path__ + "static/game-image-3-ita-a06d756e7d57b478efd6cba70ce9cd68.png";